import { render, staticRenderFns } from "./TimelineEventLabwork.vue?vue&type=template&id=1d140cdc"
import script from "./TimelineEventLabwork.vue?vue&type=script&lang=js"
export * from "./TimelineEventLabwork.vue?vue&type=script&lang=js"
import style0 from "./TimelineEventLabwork.vue?vue&type=style&index=0&id=1d140cdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports